// Why the last sign-out happened, carried across the hard navigation to
// /login (spec §17). sessionStorage, not localStorage: the answer belongs to
// this tab and this visit, and must not follow anyone around.
const KEY = "vmc.signoutReason";

/** Remember why the API signed this tab out. Storage can throw (a locked-down
 *  browser, private mode), and a missing explanation is never worth an error. */
export function stashSignoutReason(reason: string): void {
  try {
    sessionStorage.setItem(KEY, reason);
  } catch {
    // no explanation, then
  }
}

/** Forget any stashed reason — for the caller that knows the login page will
 *  not be mounting fresh to read it. */
export function clearSignoutReason(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to forget, then
  }
}

/** Read the reason and forget it: it explains one arrival at the login page,
 *  never the next reload. */
export function takeSignoutReason(): string | null {
  try {
    const reason = sessionStorage.getItem(KEY);
    clearSignoutReason();
    return reason;
  } catch {
    return null;
  }
}
